var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('van-loading',{attrs:{"size":"24px","vertical":"","show":_vm.isLoading}},[_vm._v(_vm._s(_vm.loadingTitle))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }